export default "https://d1e6s5z4lzmgxx.cloudfront.net/ba82fc54-f5ca-4442-8850-d050cbc89c21/images/mezzopiano-icon.svg?30179c12e1b63d18f502f45f35ecef1d";